<template>
  <div>
    <b-modal
      id="gtpReportModal"
      size="lg"
      content-class="menu-bg-blue-transparent-modal gtp-rpt-modal"
      title="Ground Truth Point Report"
      hide-footer
     
      scrollable
      @show="getGTPReport()"
    >
      <vue-bootstrap4-table
        :rows="gtpRows"
        :columns="gtpColumns"
        :config="config"
        :classes="classes"
      ></vue-bootstrap4-table>
    </b-modal>
  </div>
</template>

<style>
#gtpReportModal .modal-lg {
  max-width: 1200px !important;
}
.gtp-rpt-modal .menu-bg-blue-transparent-modal {
  background: transparent !important;
  color: #063c6d !important;
  text-shadow: none !important;
}
.gtp-rpt-modal table { color: #063c6d !important; text-shadow: none !important; }
.gtp-rpt-modal thead th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-shadow: none !important;
}
.gtp-rpt-modal thead th a,
.gtp-rpt-modal thead th svg { color: rgba(6, 60, 109, 0.5) !important; }
.gtp-rpt-modal tbody tr { color: #063c6d !important; text-shadow: none !important; }
.gtp-rpt-modal tbody tr:hover { background: rgba(6, 60, 109, 0.04) !important; }
.gtp-rpt-modal tbody td {
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.08) !important;
  text-shadow: none !important;
}
.gtp-rpt-modal .footer-pagination-row td,
.gtp-rpt-modal .footer-pagination-row th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  text-shadow: none !important;
}
</style>

<script>
import axios from 'axios'
import VueBootstrap4Table from 'vue-bootstrap4-table'
export default {
  name: 'MMP_GTP_Report',
  components: {
    VueBootstrap4Table
  },
  data() {
    return {
      gtpRows: [],
      gtpColumns: [
        {
          label: 'Subcountry',
          name: 'subcountry',
          sort: true
        },
        {
          label: 'Number of GTPs',
          name: 'gtpcount',
          sort: true
        }
      ],
      config: {
        checkbox_rows: false,
        card_mode: false,
        global_search: {
          visibility: true
        },
        highlight_row_hover_color: 'rgba(6,60,109,0.04)',
        per_page: 15,
        per_page_options: [10, 15, 25],
        rows_selectable: true,
        show_refresh_button: false,
        show_reset_button: false
      },
      classes: {
        table: {
          'menu-bg-blue-transparent-modal': true
        }
      }
    }
  },
  methods: {
    async getGTPReport() {
      if (sessionStorage.token) {
        await axios
          .get(process.env.API_LOCATION + '/api/gtp_tracking/getGTPReport', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            this.gtpRows = response.data.rows
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    }
  }
}
</script>
